import { Injectable } from '@angular/core';
import { Exam } from '../_models/Exam';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExamService } from '../_services/exam.service';
import { Level } from '../_models/Level';

@Injectable()
export class ListLevelsResolver implements Resolve<Level[]> {
    constructor(private examService: ExamService, private router: Router,
                private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Level[]> {
        return this.examService.getLevels().pipe(
            catchError(error => {
                this.alertify.error('problem retriving data');
                this.router.navigate(['/home']);
                return of(null);
            })
        );
    }
}